"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchUnreadMessageCountDone = exports.INBOX_FETCH_UNREAD_MESSAGE_COUNT_DONE = exports.fetchUnreadMessageCountPending = exports.INBOX_FETCH_UNREAD_MESSAGE_COUNT_PENDING = exports.fetchUnreadMessageCount = exports.INBOX_FETCH_UNREAD_MESSAGE_COUNT = void 0;
var INBOX_FETCH_UNREAD_MESSAGE_COUNT = "inbox/FETCH_UNREAD_MESSAGE_COUNT";
exports.INBOX_FETCH_UNREAD_MESSAGE_COUNT = INBOX_FETCH_UNREAD_MESSAGE_COUNT;

var fetchUnreadMessageCount = function fetchUnreadMessageCount() {
  return {
    type: INBOX_FETCH_UNREAD_MESSAGE_COUNT
  };
};

exports.fetchUnreadMessageCount = fetchUnreadMessageCount;
var INBOX_FETCH_UNREAD_MESSAGE_COUNT_PENDING = "inbox/FETCH_UNREAD_MESSAGE_COUNT/PENDING";
exports.INBOX_FETCH_UNREAD_MESSAGE_COUNT_PENDING = INBOX_FETCH_UNREAD_MESSAGE_COUNT_PENDING;

var fetchUnreadMessageCountPending = function fetchUnreadMessageCountPending() {
  return {
    type: INBOX_FETCH_UNREAD_MESSAGE_COUNT_PENDING
  };
};

exports.fetchUnreadMessageCountPending = fetchUnreadMessageCountPending;
var INBOX_FETCH_UNREAD_MESSAGE_COUNT_DONE = "inbox/FETCH_UNREAD_MESSAGE_COUNT/DONE";
exports.INBOX_FETCH_UNREAD_MESSAGE_COUNT_DONE = INBOX_FETCH_UNREAD_MESSAGE_COUNT_DONE;

var fetchUnreadMessageCountDone = function fetchUnreadMessageCountDone(payload) {
  return {
    type: INBOX_FETCH_UNREAD_MESSAGE_COUNT_DONE,
    payload: payload
  };
};

exports.fetchUnreadMessageCountDone = fetchUnreadMessageCountDone;